<form [formGroup]="form">
  <h1 mat-dialog-title>Setările formei</h1>
  <div mat-dialog-content>
    <mat-form-field appearance="fill">
      <mat-label>Nume:</mat-label>
      <input matInput formControlName="name" type="text" name="name" required autocomplete="off">
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Număr de copii:</mat-label>
      <input matInput formControlName="copyCount" type="number" step="1" min="1" max="10" name="copyCount" required autocomplete="off">
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-raised-button mat-dialog-close>Înapoi</button>
    <button mat-button mat-raised-button color="primary" [disabled]="!form.valid" (click)="onOkClick()">Salvează</button>
  </div>
</form>
